/**
 * Returns a string with all non-alphanumeric characters removed
 * @param {string} srcString
 * @returns {string} an alphanumeric string
 */
export function getJustAlphanumericCharacters(srcString) {
  // regex expression to match all
  // non-alphanumeric characters in string
  const regex = /[^A-Za-z0-9]/g;

  // use replace() method to
  // match and remove all the
  // non-alphanumeric characters
  return srcString.replace(regex, '');
}
